import { useTranslation } from 'react-i18next'

import { getFlats } from '../../../api'
import { useAsyncCallback } from '../../../hooks'
import { EntityAsyncMultiValuedInfiniteListMoreItems } from '../../Entity'
import { MultiValuedList } from '../../MultiValuedList'
import { TextMultiValuedListItem } from '../../TextMultiValuedList'
import { FlatMultiValuedListMoreItem } from '../FlatMultiValuedListMoreItem'

import { getDataItems } from './FlatAsyncMultiValuedList.utils'

function FlatAsyncMultiValuedList({
  Item = TextMultiValuedListItem,
  MoreItem = FlatMultiValuedListMoreItem,
  MoreItems = EntityAsyncMultiValuedInfiniteListMoreItems,
  apiParams,
  valuePrefixTextKey,
  ...restProps
}) {
  const { t } = useTranslation()

  const handleLoadData = useAsyncCallback(params => {
    return getFlats(params)
  }, [])

  function getPreparedDataItems(response) {
    return getDataItems({ response, t, valuePrefixTextKey })
  }

  return (
    <MultiValuedList
      {...restProps}
      Item={Item}
      MoreItem={MoreItem}
      MoreItems={MoreItems}
      moreItemsProps={{
        apiParams,
        getData: handleLoadData,
        getDataItems: getPreparedDataItems,
      }}
    />
  )
}

export default FlatAsyncMultiValuedList
